<template>
    <div class="video-player">
        <youtube :video-id="source" ref="youtube" :player-vars="options" @playing="onPlay" fitParent resize></youtube>
    </div>
</template>

<script>
export default {
    props: ['source'],

    data() {
        return {
            options: {
                autoplay: 1,
                playsinline: 1
            },
        }
    },

    methods: {
        onPlay(event) {
            if (event && event.a) this.$store.dispatch('webcasts/SET_VIDEO_HEIGHT', [event.a.clientHeight])
        }
    }
}
</script>

<style>

</style>
